import {useAuth0} from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import React from 'react';

function LogoutButton({children, onClick, ...props}) {
  const {logout} = useAuth0();
  return (
    <Button
      onClick={(...rest) => {
        logout({returnTo: window.location.origin});
        onClick?.(...rest);
      }}
      size="small"
      {...props}
    >
      {children}
    </Button>
  );
}

export default LogoutButton;
